import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#59AD3B",
      d: "M9.034 3.897V0L12.9 4.238 16 7.636l-3.155 2.882L9.035 14v-3.813C2.343 9.634 0 13.878 0 13.878c0-2.644.199-5.388 2.095-7.466C4.3 3.994 7.492 3.823 9.035 3.897Z"
    }, null, -1)
  ]))]))
}
export default { render: render }